import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { PopupMenu } from '../reusable/PopupMenu';

const testID = 'RouteDetailsPopup';

export function RouteDetailsPopup({ route, close, navigate, open }) {
  const hours = route?.duration?.hours ? `${route?.duration?.hours}h` : '';
  const minutes = route?.duration?.minutes
    ? `${route?.duration?.minutes}m`
    : '';
  return (
    <PopupMenu
      close={close}
      testID={testID}
      title={route?.name}
      addDestination={() => navigate(route)}
      id={'routeDetails'}
      open={open}
    >
      <View>
        <Text style={styles.text}>Distance: {route?.distance}mi</Text>
        <Text style={styles.text}>
          Estimated length: {hours}
          {minutes}
        </Text>
      </View>
    </PopupMenu>
  );
}

const styles = StyleSheet.create({
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  text: {
    fontSize: 20,
  },
  button: {
    position: 'absolute',
    top: -30,
    right: 10,
  },
});
